// @ts-nocheck: converted from JS

import TaskTemplates from '@/components/Tasks/Templates';

export default TaskTemplates;
